import menu from 'iconoir/icons/menu.svg';
import xmark from 'iconoir/icons/xmark.svg';
import navArrowDown from 'iconoir/icons/nav-arrow-down.svg';
import navArrowLeft from 'iconoir/icons/nav-arrow-left.svg';
import navArrowRight from 'iconoir/icons/nav-arrow-right.svg';

const media = () => {
    insertIcon(document.querySelectorAll('.navbar__toggler__icon.menu'), menu);
    insertIcon(document.querySelectorAll('.navbar__toggler__icon.xmark'), xmark);
    insertIcon(document.querySelectorAll('.page-hero__scroll-down'), navArrowDown);
    insertIcon(document.querySelectorAll('.swiper-button-prev'), navArrowLeft);
    insertIcon(document.querySelectorAll('.swiper-button-next'), navArrowRight);
}

export default media;

/**
 * Insert icon inside element
 * 
 * @param {*} els 
 * @param {*} icon 
 */

const insertIcon = (els, icon) => {
    if (els) {
        els.forEach(el => {
            fetch(icon)
                .then(r => r.text())
                .then(svg => { el.innerHTML = svg; });
        });

    }
}